// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3ekv5","btn":"styles_btn__3oZIs"};